<template>
    <div>
        <modal :name="modal_name" class="final-modal" transition="nice-modal-fade">
            <div class="v-modal-content" style="border-radius: 15px;background:#cce3fc !important;">
                <div class="pt-2 pl-0 pr-0 pb-1 m-4">
                    <div class="v-modal-body pt-0 pb-0" style="max-height: 410px;overflow-x: hidden;overflow-y: auto;">
                        <div class="d-form" style="overflow: initial !important;">
                            <i @click="manageTicket()" class="icon icon-close pull-right" style="color:#005dae;border:1px solid #005dae;border-radius:50%;padding:0px 1px;font-size:20px;cursor:pointer;"></i>
                            <div  class="text-center">
                                <img :src="getGeneralSettings.successImage || 'https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/parrot.svg'" alt="" >
                                <div class="text-success fw-500 fs-30 pt-2 pb-2">Successful! </div>
                                <div class="text-secondary fs-16 pt-2 pb-2">Your Ticket # {{api_response.ticket_number}} has been created successfully.</div>
                            </div>
                        </div>
                    </div>
                    <div class="v-modal-dialog-actions" style="border-radius: 0px 0px 15px 15px;">
                        <button type="button" @click="manageTicket()" class="btn btn-secondary btn-smm ml-3" style="box-shadow: none; border-radius: 5px !important;">
                            Manage Ticket
                        </button>
                        <button type="button" class="btn btn-success btn-smm text-white ml-4" @click="viewTicket()" style="box-shadow: none;">
                            View Ticket
                        </button>
                    </div>
                </div>
            </div>
        </modal>
    </div>  
</template>
<script>
import { EventBus } from '../eventBus/nav-bar-event'
export default {
    props:['modal_name','api_response'],
    data(){
        return{
            succesImg:''
        }
    },
    computed:{
        getGeneralSettings(){
            return this.$store.state.store.getGeneralSettings;
        },
        showPicture(){
            console.log(this.$store.state.store.showPicture)
            // return this.$store.state.store.showPicture.successImage
        },
    },
    methods:{
        manageTicket(){
            this.$router.push({
                name: 'TicketsList',
            })
        },
        viewTicket(){
            let ticket ={
                ticket_id:this.api_response.ticket_id,
                ticket_number:this.api_response.ticket_number,
                is_parent_ticket:this.api_response.is_parent_ticket
            }
            setTimeout(() => {
                EventBus.$emit('ticketSavedSuccess',ticket)
            }, 200);
            this.$router.push({ 
                name: 'TicketsList',
            })
        }
    }
}
</script>
<style scoped>

</style>